import { NgModule } from '@angular/core';
import { SketchComponent } from './sketch/sketch.component';

@NgModule({
    imports: [],
    exports: [
        SketchComponent
    ],
    declarations: [
        SketchComponent,
    ]
})
export class ConfiguratorSketchModule {}
